// @flow
import LogeDetail from 'components/entreprise/loge/LogeDetail';
import { connect } from 'react-redux';
import { fetchLogeDetail, fetchLogeList } from 'actions/logeActions';
import { displayModal } from 'actions/modalActions';
import { fetchAllContactForm } from 'actions/formActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/entreprise/loge/LogeDetail';

export default connect(
  (state: StateType): StateProps => ({
    title: state.logeDetailState.details.title,
    details: state.logeDetailState.details,
    loges: state.logeListState.loges,
    description: state.logeDetailState.details.meta_description,
    meta_title: state.logeDetailState.details.meta_title,
    meta_description: state.logeDetailState.details.meta_description,
    status: state.logeDetailState.status,
    breadcrumb_offres_entreprise: state.settingsState.breadcrumb_offres_entreprise
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchContactForm: () => dispatch(fetchAllContactForm()),
    fetchLogeDetail: (match: string) => dispatch(fetchLogeDetail(match)),
    fetchLogeList: () => dispatch(fetchLogeList()),
    displayModal: (content: Object) => dispatch(displayModal('MODAL_LOGE_FORM', content))
  })
)(LogeDetail);
